import React from "react";
import PropTypes from "prop-types";

const ChevronDown = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    case `orange`:
      color = `#e84829`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 12.42 6.57">
      <g>
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          points="0.18 0.18 6.21 6.21 12.25 0.18"
        />
      </g>
    </svg>
  );
};

ChevronDown.defaultProps = {
  className: ``,
  color: `#231f20`
};

ChevronDown.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default ChevronDown;
